// extracted by mini-css-extract-plugin
export default {"ctaLink":"Cta-module--ctaLink--x2g4l","ctaButton":"Cta-module--ctaButton--nyHVj Cta-module--ctaLink--x2g4l"};